import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { UserInfoService } from 'src/app/services/user-info.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { FooterVisibilityService } from 'src/app/services/footer-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-payment-choose-professional',
    templateUrl: './payment-choose-professional.component.html',
    styleUrls: ['./payment-choose-professional.component.scss'],
    standalone: false
})
export class PaymentChooseProfessionalComponent implements OnInit {
  public toggleDiscoundCode: boolean = false;
  public chosenPlan;
  public planPaymentType;
  public chosenPaymentType;
  public id;
  public myUser;
  public Subscription: Subscription;
  public submitted = false;
  public getCbPlan;
  public user: any;
  public refCode: any;
  public price: any;
  // Form Payment Type
  choosePlanFormGroup: UntypedFormGroup = new UntypedFormGroup({
    planPaymentType: new UntypedFormControl('perMonth'),
    hasDiscountCode: new UntypedFormControl(false),
    selectOrganization: new UntypedFormControl(''),
    discountCode: new UntypedFormControl(''),
  })

  constructor(
    private userInfoService: UserInfoService,
    private zenplansDataService: ZpDataService,
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private footerVisibilityService: FooterVisibilityService,
    public themeService: ThemeService
  ) { }

  async ngOnInit() {
    this.zenplansDataService.getUser().then(async user => {
      this.user = user;
      this.refCode = user.refCode;
      await this.zenplansDataService.setRefCode(this.refCode);
      this.getCbPlan = await this.zenplansDataService.getDynamicPricingFromChargeBee(user.refCode);
      if (this.getCbPlan) {
        this.price = this.getCbPlan.price
        this.chosenPlan = this.getCbPlan.period !== 'year' ? 'perMonth' : 'perYear';
      }
    });
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.footerVisibilityService.hideFooter = true;
    this.Subscription = this.userInfoService.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });
    await this.getMyUser();

    // Form Payment Type
    this.choosePlanFormGroup.addControl("planPaymentType", new UntypedFormControl(this.myUser.planPaymentType))
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
  }

  setPaymentType(chosenPaymentType) {
    this.chosenPlan = chosenPaymentType;
    this.planPaymentType = chosenPaymentType
  }

  // Send Form Payment Type & Form Discound
  async onSubmit() {
    this.submitted = true;
    if (this.choosePlanFormGroup.invalid) {
      return;
    }
    var chargebeeInstance = window['Chargebee'].init({
      site: this.zenplansDataService.chargeBeeSite
    });
    var self = this;
    chargebeeInstance.openCheckout({
      hostedPage: function () {
        return self.zenplansDataService.chargeBeeCheckout({});
      },
      success: async function (hostedPageId) {
        // success callback
        let data = await self.zenplansDataService.getRefCodeInfo();
        if (data.userType == "professionalManager") {
          let res = await self.zenplansDataService.chargeBeeSaveSubscriptionId(hostedPageId);
          if (res.success) {
            self.router.navigate(['/professional-manager-home-page']);
          } else {
            alert("Something failed when saving the subscription information.");
          }
        } else {
          let res = await self.zenplansDataService.chargeBeeSaveSubscriptionId(hostedPageId);
          if (res.success) {
            self.router.navigate(['/professional-home-page']);
          } else {
            alert("Something failed when saving the subscription information.");
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
    this.footerVisibilityService.hideFooter = false;
  }
}
